export default "__VITE_ASSET__HrE3A96o__"